import { render, staticRenderFns } from "./varian.vue?vue&type=template&id=5902e7ba"
import script from "./varian.vue?vue&type=script&lang=js"
export * from "./varian.vue?vue&type=script&lang=js"
import style0 from "./varian.vue?vue&type=style&index=0&id=5902e7ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports